/**
 * Normalize a string
 * @param {string} value The string to normalize
 * @returns {string} The normalized string
 */
export const normalizeStr = (value) => value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().toLowerCase();
